<template>
  <p class="pb-6">{{ text }}</p>
</template>

<script>
export default {
  name: "AtomText",
  props: ["text"]
};
</script>